<template>

    <div class="loading-filter">
        <div class="loading-box">
            <div class="loading-item" v-for="i in 5">
                <div class="circle animation w-48px h-48px flex-shrink"></div>
                <div class="w-100">
                    <div class="pill animation w-10 mb-4px"></div>
                    <div class="pill animation w-50"></div>
                </div>
                <div class="circle animation flex-shrink"></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'LoadingFilter',
        props: {
            type: String
        }
    }
</script>

<style scoped src="../../assets/css/loading/index.css"></style>

<style scoped>
.loading-filter {
    padding: 16px 8px;
    background-color: var(--color-background-default-default) ;
}
.loading-box {
    padding: 16px 8px;
    border-radius: 16px;
    background-color: var(--color-background-default-secondary);
    /* padding-top: calc(35px + 8px); */
}
.loading-item {
    border-radius: 8px;
    margin-bottom: 4px;
    background-color: var(--color-background-default-tertiary);
    display: flex;
    align-items: center;
    padding: 16px;
    justify-content: space-between;
    gap: 16px;
}
</style>